import { IBasePathParams } from 'common/models/requestModels';

export interface IUserModel extends Components.Schemas.UserDto {
  name?: string;
  mappedRole?: string;
  isPayMongoAPIKeysSet?: boolean;
}
export interface IUserCollection extends Components.Schemas.UserCollection {}
export interface IUserUpdateData extends Components.Schemas.UpdateUserDto {}
export interface IUserInviteData extends Components.Schemas.CreateUserDto {}
export interface IUserUpdatePasswordData extends Components.Schemas.UpdatePasswordDto {}
export interface IUserConfirmData extends Components.Schemas.JoinUserDto {}
export interface IFranchiseeData extends Components.Schemas.ShortFranchiseeDto {}
export interface IUserCollectionFilter extends Paths.UserControllerList.QueryParameters {
  pageIndex?: number;
}

export interface IPayMongoAPIKeys extends Components.Schemas.PayMongoApiKeysDto {}
export interface IPayMongoState extends Components.Schemas.PayMongoConfigStatusDto {}
export interface IOtpModel extends Components.Schemas.OtpDto {}

export interface IUserModelParams {
  path?: IBasePathParams;
  data?: IUserInviteData | IUserUpdateData | IUserUpdatePasswordData | IPayMongoAPIKeys;
}

export enum EUserRole {
  // ponytail: value must match the api role enum the parallel agent adds (`'superadmin'`).
  SuperAdmin = 'superadmin',
  Franchisor = 'franchisor',
  Franchisee = 'franchisee',
  Manager = 'manager',
  SalesOps = 'salesop',
  Customer = 'customer',
}
export enum EUserRoleText {
  SuperAdmin = 'Super Admin',
  Franchisor = 'Franchisor',
  Franchisee = 'Franchisee',
  Manager = 'Manager',
  SalesOps = 'Sales Ops',
  Customer = 'Customer',
}

export const roleDict = {
  [EUserRole.SuperAdmin]: EUserRoleText.SuperAdmin,
  [EUserRole.Franchisor]: EUserRoleText.Franchisor,
  [EUserRole.Franchisee]: EUserRoleText.Franchisee,
  [EUserRole.SalesOps]: EUserRoleText.SalesOps,
  [EUserRole.Manager]: EUserRoleText.Manager,
  [EUserRole.Customer]: EUserRoleText.Customer,
};

export enum EUserStatus {
  Active = 'active',
  Blocked = 'blocked',
  Pending = 'pending',
}
export enum EUserStatusText {
  Active = 'Active',
  Blocked = 'Blocked',
  Pending = 'Pending',
}

export const tableUserConfig = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    ellipsis: true,
  },
  {
    title: 'Phone Number',
    dataIndex: 'phone',
    key: 'phone',
    ellipsis: true,
  },
  {
    title: 'Role',
    dataIndex: 'mappedRole',
    key: 'mappedRole',
    ellipsis: true,
  },
  {
    title: 'Position',
    dataIndex: 'profileName',
    key: 'profileName',
    ellipsis: true,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
  },
];

export enum EUserSuccessMessage {
  SetAPIKeys = 'API Keys have been successfully set up. Now you can accept payments.',
  ResetAPIKeys = 'API Keys have been successfully reset.',
  ChangePassword = 'Password successfully changed',
  ReInviteSend = 'Invitation has been sent to the specified email',
  Delete = 'Invitation has been successfully cancelled',
  Invite = 'Employee has been successfully invited',
  Edit = 'Employee has been successfully edited',
}
